import React, {Component} from 'react';
import {render} from 'react-dom';
import config from 'config';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import DeadLineExpress from 'Assets/deadlineexpress.png';
import { userService } from '../_services';
import styles from './Navigation.module.css';

export default class Navigation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            token: {}
        };
    }

    componentDidMount() {
        this.setState({ 
            token: JSON.parse(localStorage.getItem('token'))
        });
    }

    isActive(value){
        return 'nav-link '+((value===this.props.active) ?'active':'');
    }
  
    render() {

        var privileges = null;

        if (this.props.authenticatedUser) {
            privileges = this.props.authenticatedUser.privileges;
        }

        return (
            <nav className="navbar navbar-default navbar-deadline padding-lr40" styleName="styles.navbar-deadline">
                <div className="container-fluid">
                    <div className="navbar-header">
                        <a href={config.companyUrl}>
                            <img styleName="styles.logo" src={DeadLineExpress} alt="Deadline Express" />
                        </a>
                        {
                            privileges &&
                            <button type="button" className="navbar-toggle collapsed"
                                data-toggle="collapse" data-target="#deadline-nav"
                                aria-expanded="false"
                                >
                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                            </button>
                        }
                    </div>
                    <div id="deadline-nav" className="collapse navbar-collapse">
                        <ul className="nav navbar-nav deadline-nav-tabs">
                            {privileges && (_.some(privileges,['description', "Job Booking"])) &&
                                <li className={this.isActive("booking")}><Link to="/">Job Booking</Link></li>
                            }
                            {privileges && (_.some(privileges, ['description', "Job Query"])) &&
                                <li className={this.isActive("query")}><Link to="/query">Job Query</Link></li>
                            }
                            {privileges && (_.some(privileges, ['description', "Invoices"])) &&
                                <li className={this.isActive("invoices")}><Link to="/invoices">Invoices</Link></li>
                            }
                            {privileges &&
                                _.some(privileges, ['description', "Maintenance"]) &&
                                privileges.some((a) => ["Maintain Web Users","View Frequent Addresses","Modify Booking Options","Manage References"].indexOf(a.description) != -1) &&
                                <li className={"dropdown " + (("admin"===this.props.active) ?'active':'')}>
                                    <a className="dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">Admin<span className="caret"></span></a>
                                    <ul className="dropdown-menu">
                                        {privileges && (_.some(privileges, ['description', "Maintain Web Users"])) &&
                                            <li><Link to="/admin_users">Users</Link></li>
                                        }
                                        {privileges && (_.some(privileges, ['description', "View Frequent Addresses"])) &&
                                            <li><Link to="/admin_addresses">Frequent Addresses</Link></li>
                                        }
                                        {privileges && (_.some(privileges, ['description', "Modify Booking Options"])) &&
                                            <li><Link to="/admin_booking_options">Booking Options</Link></li>
                                        }
                                        {privileges && (_.some(privileges, ['description', "Manage References"])) &&
                                            <li><Link to="/admin_booking_references">Booking References</Link></li>
                                        }
                                    </ul>
                                </li>
                            }
                        </ul>
                    
                        {privileges &&
                        <ul className="nav navbar-nav navbar-right">
                            <li className="dropdown">
                                <a href="#" className="btn btn-link btn-lg pull-left dropdown-toggle" data-toggle="dropdown">
                                    <span className="glyphicon glyphicon-user"></span> User 
                                </a>
                                <ul className="dropdown-menu">
                                    {
                                        this.props.authenticatedUser && <li><a>{this.props.authenticatedUser.name}</a></li>
                                    }
                                    {
                                        this.props.authenticatedUser && <li><Link to="/user_preferences">Preferences</Link></li>
                                    }
                                    {
                                        this.props.authenticatedUser && <li><Link to="/change_password">Change Password</Link></li>
                                    }
                                    <li><Link to="/login">Logout</Link></li>
                                </ul>
                            </li>
                        </ul>
                        }
                    </div>
                </div>
            </nav>
        )
    }
}